module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAaCAYAAACU2C2oAAAAAXNSR0IArs4c6QAAAFhJREFUKFPl0bEJgEAMBdBn4w4Op2Nop6DNOYYOp2vIoTaH1wkWpgnkQUL4BUqMaJy1oi8Q0F3Du80RNlQJ7DnYcqtChPT4giHCY70M//58Qp1mPqP9IvMDcIUgzQjmFcsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/space/iv_three_dot.png
// module id = pf+S
// module chunks = 1